import React,{useEffect,useState} from "react";
import axios from "axios";

const Download= () => {
    const download=async () => {
        const response = await fetch("https://zhivay.com/factor/U1M8CJYerYjiyZm");
        const blob = await response.blob();
        console.log(blob);
    }
    download();
    return (
        <div>
            download
        </div>
    )
}
export default Download;